import apiHandler from './apiHandler';

const EmailEvents = async (request) => {
  try {
    const response = await apiHandler({
      endpoint2: '/crsbookings/getEmailDetail',
      method: 'POST',
      data: request,
    });

    if (response.response_code == 200) {
      return response;
    } else {

      throw new Error(response.message || 'Failed to fetch email events');
    }
  } catch (error) {
    console.error("Error fetching Email Events ", error);
    throw error;
  }
};

export default EmailEvents;